/*  removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
 */
export function removeStorage(key) {
  try {
    localStorage.setItem(key, "");
    localStorage.setItem(key + "_expiresIn", "");
  } catch (e) {
    throw new Error(
      "removeStorage: Error removing key [" +
        key +
        "] from localStorage: " +
        e.message
    );
  }
  return true;
}

/*  getStorage: retrieves a key from localStorage previously set with setStorage().
            params:
                key <string> : localStorage key
            returns:
                <string> : value of localStorage key
                null : in case of expired key or failure
         */
export function getStorage(key) {
  const now = Date.now(); //epoch time, lets deal only with integer
  // set expiration for storage
  let expiresIn = localStorage.getItem(key + "_expiresIn");
  if (expiresIn === undefined || expiresIn === null) {
    expiresIn = 0;
  }

  expiresIn = Math.abs(expiresIn);
  if (expiresIn < now) {
    // Expired
    removeStorage(key);
    return null;
  } else {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      throw new Error(
        "getStorage: Error reading key [" +
          key +
          "] from localStorage: " +
          e.message
      );
    }
  }
}

/*  setStorage: writes a key into localStorage setting an expiration time
            params:
                key <string>     : localStorage key
                value <string>   : localStorage value
                expires <number> : number of seconds from now to expire the key
            returns:
                <boolean> : telling if operation succeeded
         */
export function setStorage(key, value, expires) {
  if (expires === undefined || expires === null) {
    expires = 24 * 60 * 60; // default: seconds for 1 day
  }

  const now = Date.now(); // milliseconds since epoch time
  const schedule = now + expires * 1000;
  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + "_expiresIn", schedule);
  } catch (e) {
    throw new Error(
      "setStorage: Error setting key [" +
        key +
        "] in localStorage: " +
        e.message
    );
  }
  return true;
}
